import { formatUnits } from "ethers"

export const formatAddress = (address: string) => {
    return `${address.substring(0, 6)}...${address.substring(address.length - 4, address.length)}`
}

export const formatBalance = (balance: bigint, decimals: number) => {
    const splitBalance = formatUnits(balance, 'ether').split('.')
    
    return `${splitBalance[0]}.${splitBalance[1].slice(0, decimals)}`
}